export * from './app-bugreporting.component';



// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/components/app-bugreporting/index.ts